import BaseModel from '../../base';
import constants, { TEAM_MEMBER_STATUS } from './constants';

export default class TeamMember extends BaseModel {
  constructor(member = {}, url = 'users') {
    super(member, url);

    Object.assign(this, member);

    this.status = member.status ?? TEAM_MEMBER_STATUS.STATUS_REQUEST;
    this.role_id = member.role_id ?? member.team_role_id ?? null;
    this.coaching_team_id = member.coaching_team_id ?? null;
    this.joined_at = member.joined_at || null;
    this.left_at = member.left_at || null;
    this.excluded_at = member.excluded_at || null;
    this.excluded_by = member.excluded_by || null;
    this.is_captain = member.is_captain ?? false;

    this.coaching_team = member.coaching_team || null;
  }

  static get constants() {
    return constants;
  }
}
